import { Form, Formio } from "@formio/react"
import React, { useEffect, useRef, useState } from 'react'
import {
  CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem,
  CModal,
  CModalBody,
  CModalHeader,
  CButton,
  CModalTitle,
  CModalFooter,
  CFormLabel,
} from '@coreui/react'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api';
import SaveQuestionProvider from '../../services/general/saveQuestionsProvider.api';
import GetPatientDiagnosisDetails from '../../services/general/getPatientDiagnosisDetails.api';
import GetQuestionBank from "../../services/general/saveQuestionBank.api";
import PatientQuestionPoa from "./PatientQuestionPoa";
import Pageloader from "../../components/shared/Pageloader";
import { useIndexedDB } from "../../context/IndexedContext";
import Graytextarea from "../../components/Graytextarea";
import { Calendar, Edit, FilePlus2, Plus, Trash } from "lucide-react";
import SaveExtra from "../../services/general/saveExtraData.api";
const ProviderPoac = ({ patientID, loading, setLoading, saveTreatsShell, togglePoacFreetype, setTogglePoacFreetype, patientTreatments, noteID, noteStructureRef, patientDiagnosis, showOnlyNoteDiagnosis, noteCallType }) => {
  const [fetching, setFetching] = useState(false);
  const [newComponents, setNewComponents] = useState([]);
  const [questionValue, setQuestionsValue] = useState([])
  const [formAnswers, setFormAnswers] = useState([])
  const [questions, setQuestions] = useState([])
  const [formValue, setFormValues] = useState([])
  const [dataWithoutValues, setDataWithoutValues] = useState([])
  const formData = useRef([])
  let tempData = []

  const { getPOACMaster, getOfflineData, getProviderDetails, getCallCenterQuestions, saveCallCenterQuestions, saveOfflineData, saveOpenChartOfflineData, getOpenChartOfflineData } = useIndexedDB()
  const userData = JSON.parse(localStorage.getItem('user'))
  const role = userData?.Role

  // add texts
  const [freetypes, setFreeTypes] = useState([]);
  const [tempFreetypeValue, setTempFreetypeValue] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [editFreetypeId, setEditFreetypeId] = useState(null);

  console.log(freetypes, 'freetypes')

  const freetypeKey = `${patientID}-${noteID}`;

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("patientNoteFreeTypesPoac") || "{}");
    console.log(stored, 'stored')
    setFreeTypes(stored[freetypeKey] || []);
  }, []);

  const handleAddFreetype = () => {
    if (!tempFreetypeValue.trim()) return;

    const storedData = JSON.parse(localStorage.getItem("patientNoteFreeTypesPoac") || "{}");

    if (!storedData[freetypeKey]) storedData[freetypeKey] = [];

    if (isEditing && editFreetypeId) {
      const updatedList = storedData[freetypeKey].map(item => {
        if (item.id === editFreetypeId) {
          return {
            ...item,
            text: tempFreetypeValue,
          };
        }
        return item;
      });
      storedData[freetypeKey] = updatedList;
      setFreeTypes(updatedList);
      setIsEditing(false);
      setEditFreetypeId(null);
    } else {
      const newItem = {
        id: Date.now(),
        date: new Date().toISOString(),
        text: tempFreetypeValue
      };
      const updatedList = [...storedData[freetypeKey], newItem];
      storedData[freetypeKey] = updatedList;
      setFreeTypes(updatedList);
    }

    // Save back to localStorage
    localStorage.setItem("patientNoteFreeTypesPoac", JSON.stringify(storedData));

    // Reset modal input
    setTempFreetypeValue("");
    setTogglePoacFreetype(false);
  };


  const handleCancelFreetype = () => {
    setTempFreetypeValue("");
    setTogglePoacFreetype(false);
  };

  const handleDEeleteFreetype = (id) => {
    const storedData = JSON.parse(localStorage.getItem("patientNoteFreeTypesPoac") || "{}");
    const updatedList = storedData[freetypeKey].filter(item => item.id !== id);
    storedData[freetypeKey] = updatedList;
    setFreeTypes(updatedList);
    localStorage.setItem("patientNoteFreeTypesPoac", JSON.stringify(storedData));
  };


  const formioOptions = {
    readOnly: true,
    renderMode: 'html'
  };
  const filterEmptyAnswers = (data) => {
    return data
      .filter(item => typeof item === 'object' && !Array.isArray(item))
      .map((item) => {
        return {
          ...item,
          data: Object.fromEntries(
            Object.entries(item.data).filter(([key, value]) => value !== "")
          ),
        };
      });
  };

  // const getCallCenterData = async (diagnosisList) => {
  //   setFetching(true)
  //   const getProviderDetailsData = await getProviderDetails()
  //   const getOfflineDataOfPatient = await getOfflineData()
  //   let tempAnswers = getOfflineDataOfPatient[getProviderDetailsData?.ID]?.[patientID]?.tempAnswersGetPatientDiagnosisDetails || []

  //   // let tempAnswers = await GetPatientDiagnosisDetails(patientID)
  //   try {
  //     let data = JSON.parse(tempAnswers.d)
  //     let formAnswersStr = data.Data[0].DiagnosisDetails
  //     let tempData = JSON.parse(formAnswersStr)
  //     let resultData = filterEmptyAnswers(tempData)
  //     setDataWithoutValues(resultData.map(item => item.data).reduce((acc, obj) => ({ ...acc, ...obj }), {}))
  //     setFormAnswers(tempData)
  //     setFormValues(resultData)


  //   } catch (e) {

  //   }
  //   const updatedComponents = [];

  //   for (let a = 0; a < diagnosisList.length; a++) {
  //     try {
  //       formData.current.push([])
  //       try {
  //         let component = []
  //         const POACMaster = await getPOACMaster()
  //         // let c = await GetQuestionBank("", diagnosisList[a], "") 
  //         let c = POACMaster[diagnosisList[a]];
  //         component = JSON?.parse(c?.d)
  //         updatedComponents.push({ diagnosis: diagnosisList[a], component: component });
  //       } catch (e) {
  //         console.log("error ", e)
  //       }
  //     } catch (e) {
  //       console.log("Error Fetching Diagnosis Data: ", diagnosisList[a], e)
  //     }
  //   }
  //   setNewComponents(updatedComponents);
  //   setFetching(false)

  // }



  const getLatestNoteByPatientAndNoteID = (allPatientHpiData, patientID,) => {

    const filtered = allPatientHpiData.filter((item) => {
      const patientData = item[patientID]
      // /  return patientData && patientData[noteID]
      return patientData
    })
    console.log(filtered, 'filtered getLatestNoteByPatientAndNoteID')

    const latest = filtered.at(-1)
    console.log(latest, 'latest getLatestNoteByPatientAndNoteID')
    return latest || null
  }
  const [freeTypeGlobal, setFreeTypeGlobal] = useState('')
  const getCallCenterData = async (diagnosisList) => {
    setFetching(true)

    // let data = await SaveExtra('Get_By_Type', 'CallCenterQuestions', '', '');
    // let allData = JSON.parse(data?.d);
    let allData = await getCallCenterQuestions();


    console.log('patinet id allData ', allData);

    const allPatientHpiData = allData?.Data?.map((item) => {
      return {
        ...JSON.parse(item?.JsonData),
        CreatedAt: item?.CreatedAt,
      };
    });

    const result = getLatestNoteByPatientAndNoteID(allPatientHpiData, patientID);

    console.log("call center latest data ---> ", result);


    const convertedData = {};

    const callCenterData = result?.[patientID]?.CCENTER;
    const globalFreeType = result?.[patientID]?.globalFreeType

    if (callCenterData) {
      Object.keys(callCenterData).forEach((diagnosis) => {



        convertedData[diagnosis] = callCenterData[diagnosis]?.map((q) => ({
          question: q.label,
          answer: q.answer,
          freeType: q.freeType,
          type: q?.type,
          freewayRemark: q?.freewayRemark
        }));
      });
    }

    setFreeTypeGlobal(globalFreeType)
    setGlobalRemarkText(globalFreeType)
    setQuestionsValue(convertedData);
    console.log("Converted Call Center Data", convertedData);

    setFetching(false)

    return convertedData;
  };
  useEffect(() => {
    getCallCenterData(patientDiagnosis)
  }, [])


  const [saving, setSaving] = useState(false)





  const addedCallCenterData = async (Mode, callCenterData, id) => {
    const data = noteCallType === 'OpenChart' ? await getOpenChartOfflineData() : await getOfflineData()
    const loggedUser = await getProviderDetails()
    const loggedUserID = loggedUser?.ID
    const userData = { ...(data[loggedUserID] || {}) }
    const patientData = { ...(userData[patientID] || {}) }
    const newlyAddedData = patientData.newlyAddedData || []



    const tempOrderId = Math.floor(100 + Math.random() * 900)

    const callCenter = {
      id: id,
      CCenter: callCenterData,
      Mode
    }
    const updatedPatientData = {
      ...patientData,
      newlyAddedData: { ...newlyAddedData, callCenter },
    }

    const updatedUserData = {
      ...userData,
      [patientID]: updatedPatientData,
    }

    const updatedData = {
      ...data,
      [loggedUserID]: updatedUserData,
    }

    console.log('ordeer update in ls ', updatedData,)
    noteCallType === 'OpenChart' ? await saveOpenChartOfflineData(updatedData) : await saveOfflineData(updatedData)

    // setPatientDBData(updatedPatientData)
  }



  const UpdateCallCenterData = async (Mode, callCenterData, id) => {
    let allData = await getCallCenterQuestions();
    const dataArray = allData?.Data || [];

    await addedCallCenterData(Mode, callCenterData, id);

    const index = dataArray.findIndex(item => item?.Id === id);


    let updatedData;

    if (index !== -1) {

      updatedData = dataArray.map(item =>
        item?.Id === id
          ? {
            ...item,
            JsonData: JSON.stringify(callCenterData),
          }
          : item
      );
    } else {

      updatedData = [
        ...dataArray,
        {
          Id: id,
          JsonData: JSON.stringify(callCenterData),
          CreatedAt: new Date().toISOString(),
        },
      ];
    }

    allData = {
      ...allData,
      Data: updatedData,
    };

    if (updatedData.length > 0) {
      await saveCallCenterQuestions(allData);
    }

    await getCallCenterData(patientDiagnosis);
    console.log("updatedData >", updatedData);
  };

  const handleSubmit2 = async () => {
    setSaving(false)

    // let data = await SaveExtra('Get_By_Type', 'CallCenterQuestions', '', '')
    // let allData = JSON.parse(data?.d)
    let allData = await getCallCenterQuestions();
    const allPatientHpiData = allData?.Data?.map((item) => {
      console.log(patientID, Number(noteID), 'latestPatientHPISecondTimeNoteWithSubjective')
      return {
        Id: item?.Id,
        ...JSON.parse(item?.JsonData),
        CreatedAt: item?.CreatedAt,
      }
    })

    console.log('latestPatientHPISecondTimeNoteWithSubjective 2', allPatientHpiData)
    const result = getLatestNoteByPatientAndNoteID(allPatientHpiData, patientID, noteID)
    // const result = allPatientHpiData

    const latestPatientHPISecondTimeNoteWithSubjective = result?.[patientID] || null

    console.log("latest data HPI", result, latestPatientHPISecondTimeNoteWithSubjective)

    if (latestPatientHPISecondTimeNoteWithSubjective) {


      const finalHpiStructure = {
        [patientID]: {
          CCENTER: latestPatientHPISecondTimeNoteWithSubjective?.CCENTER,
          globalFreeType: globalRemarkText || '',
        },
      }
      console.log(JSON.stringify(finalHpiStructure), finalHpiStructure, 'finalHpiStructure while note 0')

      // await SaveExtra('UPDATE', 'CallCenterQuestions', JSON.stringify(finalHpiStructure), result?.Id)
      await UpdateCallCenterData('UPDATE', finalHpiStructure, result?.Id)
      // const hpidata = await fetchPatientFinalNoteDetails()
      // await getQuestionForDiagnosis(hpidata)
    }


    else {

      let data = await SaveExtra('Get_By_Type', 'CallCenterQuestions', '', '')
      let allData = JSON.parse(data?.d)
      const allPatientHpiData = allData?.Data?.map((item) => {
        return {
          Id: item?.Id,
          ...JSON.parse(item?.JsonData),
          CreatedAt: item?.CreatedAt,
        }
      })

      if (patientID) {
        const finalHpiStructure = {
          [patientID]: {
            CCENTER: {},
            globalFreeType: globalRemarkText || '',
          },
        }
        const tempOrderId = Math.floor(100 + Math.random() * 900)
        console.log(finalHpiStructure, allPatientHpiData, 'finalHpiStructure update')
        await UpdateCallCenterData('INSERT', finalHpiStructure, tempOrderId)
        // await SaveExtra('INSERT', 'CallCenterQuestions', JSON.stringify(finalHpiStructure), '')

      }
    }
    setSaving(false)
  }




  const [visible, setVisible] = useState(false)
  const [showGlobalRemarkModal, setShowGlobalRemarkModal] = useState(false)
  const [addingGlobalRemarkLoading, setAddingGlobalRemarkLoading] = useState(false)
  const [globalRemarkTextToShow, setGlobalRemarkTextToShow] = useState('')
  const [globalRemarkText, setGlobalRemarkText] = useState('')

  const handleAddGlobalRemarkPE = async () => {
    // const a = await add
    setAddingGlobalRemarkLoading(true)
    // await handleAddPeGlobalRemarkOffline()
    setFreeTypeGlobal(globalRemarkText)
    console.log("globalRemarkText", globalRemarkText)
    await handleSubmit2()
    // let response = await PatientPhysicalExaminationData('Insert', patientID, noteID, 'PhysicalExaminationGlobalRemark', JSON.stringify({ globalRemarkText }))

    setShowGlobalRemarkModal(false)
    setAddingGlobalRemarkLoading(false)
    // await fetchData()
  }






  if (fetching) {
    return <Pageloader isLoading={fetching} />
  }



  return (
    <>
      <div className={`  ${role == 'provider' ? 'accordion-dark' : ' '} d-flex flex-column gap-4 `}>
        <div className="d-flex align-items-center gap-2 px-4 py-2" style={{ background: '#191919' }}>
          <h7 className="fs-7  ">POAC</h7>
          <div></div>
          <>

            <CFormLabel
              className="d-flex mt-2 flex-column align-items-center justify-content-center shadow "
              onClick={() => setShowGlobalRemarkModal((p) => !p)}
              style={{
                width: '30px',
                height: '30px',
                borderRadius: '20px',
                background: '#4363F2',
                cursor: 'pointer',
              }}
            >
              <FilePlus2 className="text-white" strokeWidth={2} size={15} />
            </CFormLabel>
          </>
        </div>
        {freeTypeGlobal && <div style={{ whiteSpace: "pre-line" }}>{freeTypeGlobal} </div>}
        {patientDiagnosis.length > 0 ? (
          <CAccordion className={` d-flex flex-column gap-2 ap`}>
            {patientDiagnosis
              ?.sort((a, b) => a.localeCompare(b))
              ?.map((obj, i) => {
                const data = questionValue?.[obj] || [];


                // if (!data.length) return null;



                return (
                  <CAccordionItem key={i} itemKey={i + 1} className="border  ">
                    <CAccordionHeader>{obj}</CAccordionHeader>
                    <CAccordionBody>
                      <div className="" style={{ marginBottom: '10pt' }}>

                        {data.map((item, index) => (
                          <div
                            className="mt-1"
                            key={index}
                            style={{
                              //  textDecoration: (item?.type == 'Header' || item?.type == 'subHeader') ? 'underline' : 'none',
                              fontWeight: (item?.type == 'Header' || item?.type == 'subHeader') ? 'bold' : 'none',
                              fontSize: item?.type == 'Header' ? '15.5px' : '',
                              gap: '5px',
                              margin: 0,
                              color: 'white !important'


                            }}
                          >

                            {item?.freewayRemark && <div>{item?.freewayRemark} </div>}

                            <div className="d-flex">
                              <p style={{ margin: 0 }}>
                                <span
                                  style={{
                                    fontWeight: 'bold',
                                    textDecoration: item?.type === 'Header' ? 'underline' : 'none',
                                    fontSize: item?.type === 'Header' ? '16.5px' : '15px',
                                  }}
                                >
                                  {item?.type === 'Header'
                                    ? item.question
                                    : item?.type === 'subHeader'
                                      ? `${item.question} :`
                                      : `${item.question} - `}
                                </span>

                                <span
                                  style={{
                                    fontSize: '14px',
                                    color: '#fff',
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: item.answer?.replace(/color\s*:\s*[^;"]+;?/gi, ''),
                                  }}
                                />
                              </p>
                            </div>

                            {item?.freeType && <div><strong>FreeType:</strong> <span className="text-white" style={{
                              fontSize: '14px',
                              color: '#fff',
                            }} dangerouslySetInnerHTML={{ __html: item?.freeType?.replace(/color\s*:\s*[^;"]+;?/gi, '') }}></span> </div>}
                          </div>
                        ))}
                      </div>


                      {data.length === 0 && (
                        <div
                          style={{
                            fontSize: '15px',
                            fontWeight: '600px',
                            color: 'gray'
                          }}
                        >
                          No Data Available
                        </div>
                      )}
                    </CAccordionBody>
                  </CAccordionItem>
                )
              })}
          </CAccordion>
        ) : (
          <div className="d-flex justify-content-center align-items-start text-muted" style={{ height: "50px" }}>
            <div
              style={{
                fontSize: '15px',
                fontWeight: '600px',
                color: 'gray'
              }}
            >
              No Data Available
            </div>
          </div>
        )}
      </div>

      <div className="d-flex flex-column gap-3 mt-4">
        {
          freetypes.length > 0 && freetypes.map((item, idx) => {
            return (
              <div className="d-flex flex-column gap-2 p-3" style={{ background: '#191919', borderRadius: "10px" }}>
                <div className="d-flex align-items-center justify-content-between">
                  <span className="d-flex gap-2 align-items-center">
                    <Calendar strokeWidth={2} size={20} />
                    <p className="m-0">{new Date(item?.date).toLocaleDateString()}</p>
                  </span>
                  <span className="d-flex gap-2 align-items-center">
                    <Edit
                      onClick={() => {
                        setEditFreetypeId(item.id)
                        setTogglePoacFreetype(true)
                        setIsEditing(true)
                        setTempFreetypeValue(item.text)
                      }}
                      strokeWidth={2} size={20} />
                    <Trash
                      onClick={() => {
                        handleDEeleteFreetype(item.id)
                      }}
                      strokeWidth={2} size={20} />
                  </span>
                </div>
                <div>
                  {item.text}
                </div>
              </div>
            )
          })
        }
      </div>

      <CModal
        visible={togglePoacFreetype}
        size="lg"
        centered
        alignment="center"
        onClose={() => setTogglePoacFreetype(false)}
      >
        <CModalHeader
          style={{
            backgroundColor: '#282828',
            borderBottom: '1px solid gray',
            color: 'white',
            justifyContent: 'center',
          }}
          closeButton
          closeButtonProps={{ style: { filter: 'invert(1)' } }}
        >
          <CModalTitle style={{ color: 'white' }}>Add Freetype</CModalTitle>
        </CModalHeader>

        <CModalBody style={{ backgroundColor: '#282828', color: 'white' }}>
          <Graytextarea
            style={{
              backgroundColor: '#191919',
              color: 'white',
              border: '1px solid #444',
              height: '200px',
            }}
            placeholder="Enter freetype"
            value={tempFreetypeValue}
            onChange={(e) => setTempFreetypeValue(e.target.value)}
          />
        </CModalBody>

        <CModalFooter
          style={{
            backgroundColor: '#282828',
            borderTop: '1px solid gray',
            justifyContent: 'center',
            gap: '10px',
            padding: '10px',
          }}
        >
          <CButton
            style={{ backgroundColor: '#4363F2', color: 'white', border: 'none' }}
            onClick={handleAddFreetype}
          >
            {isEditing ? 'Update' : 'Add'}
          </CButton>

          <CButton
            style={{ backgroundColor: '#333', color: 'white', border: 'none' }}
            onClick={handleCancelFreetype}
          >
            Cancel
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal backdrop="static" visible={showGlobalRemarkModal} onClose={() => setShowGlobalRemarkModal(false)} aria-labelledby="StaticBackdropExampleLabel">
        <CModalHeader style={{ background: '#282828', color: 'white' }}>
          <CModalTitle style={{ color: 'white' }} id="StaticBackdropExampleLabel">
            Add Remark
          </CModalTitle>
        </CModalHeader>
        <CModalBody
          style={{
            overflowY: 'auto',
            color: 'white',
            padding: '24px',
            backgroundColor: '#282828',
          }}
        >
          <Graytextarea
            style={{
              backgroundColor: '#282828',
              color: 'white',
              border: '1px solid #989898',
              height: '200px',
            }}
            placeholder="Enter remark for POAC"
            value={globalRemarkText}
            rows={4}
            onChange={(e) => setGlobalRemarkText(e.target.value)}
          />
        </CModalBody>
        <CModalFooter style={{ background: '#282828' }}>
          <CButton
            style={{
              backgroundColor: '#333', // dark gray
              border: '1px solid gray',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
            color="secondary"
            onClick={() => setShowGlobalRemarkModal(false)}
          >
            Close
          </CButton>
          <CButton
            onClick={async () => {
              await handleAddGlobalRemarkPE()
            }}
            style={{
              backgroundColor: '#4363F2', // blue
              border: 'none',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
            variant="outline"
            color="primary"
          >
            {addingGlobalRemarkLoading ? 'Saving...' : 'Save'}
          </CButton>
        </CModalFooter>
      </CModal>

    </>
  )
}

export default ProviderPoac